import { UserService } from "../Services/UserService";
import { authenticateRequest } from "../Types/RequestResponse/authenticateRequest";

export const useLogin = () => {
  const Login = async (formValues: any, companyId?: number) => {
    const createLoginRequest: authenticateRequest = {
      email: formValues.email,
      password: formValues.password,
      companyId: companyId,
    }

    return await UserService.Authenticate(createLoginRequest);
  };
  return {
    Login
  };
};